/* eslint-disable */

import { createContext, useContext, useState } from "react";
import { ValueModal } from "../shared/components/ValueModal";

const ModalContext = createContext({});

export function ModalProvider({ children }) {
  const [isOpen, setIsOpen] = useState(false);

  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);

  return (
    <ModalContext.Provider value={{ openModal, closeModal }}>
      {children}
      <ValueModal
        isOpen={isOpen}
        onClose={closeModal}
      />
    </ModalContext.Provider>
  );
}

export function useModal() {
  return useContext(ModalContext);
}
